import { useState, useEffect, useMemo, useContext } from 'react';
import { Breadcrumb } from './../common/Breadcrumb';
import InfoCards from './../common/InfoCards';
import TableWithPagination from './../common/TableWithPagination';
import { Icon } from '@iconify/react';
import dayjs from 'dayjs';
import { useApi } from './../../hooks/useApi';
import HistorialProceso from './HistorialProceso';
import { API_URLS } from './../../api/apiUrls';
import { AuthContext } from '../../context/AuthContext';
import Modal from '../common/Modal';
import { toast } from 'react-toastify';
import ConfirmDialog from './../common/ConfirmDialog';


export default function BlockedProcessesModule() {
  const { get, post, loading, error } = useApi();
  const formatDate = (date) => (date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '');
  const { user } = useContext(AuthContext);
  

  const [vistaActiva, setVistaActiva] = useState('procesosBloqueados');
  const [procesosBloqueados, setProcesosBloqueados] = useState([]);
  const [archivosBloqueados, setArchivosBloqueados] = useState([]);
  const [procesoSeleccionado, setProcesoSeleccionado] = useState(null);
  const [mostrarHistorial, setMostrarHistorial] = useState(false);
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);
  const [archivosArchivados, setArchivosArchivados] = useState([]);
  const [mostrandoArchivados, setMostrandoArchivados] = useState(false);

  // bloqueo y desbloque proceso
  const [modalOpen, setModalOpen] = useState(false);
  const [comentario, setComentario] = useState('');
  const [procesoTarget, setProcesoTarget] = useState(null);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [procesoId, setProceso] = useState(null);

  // Bloqueo de archivos 
  const [modalOpenFile, setModalOpenFile] = useState(false);
  const [archivoTarget, setArchivoTarget] = useState(null);
  const [comentarioArchivo, setComentarioArchivo] = useState('');
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [errorNombreArchivo, setErrorNombreArchivo] = useState('');
  const [errorProcesoId, setErrorProcesoId] = useState('');

  const [showConfirm, setShowConfirm] = useState(false);
  


  const onBloqueoArchivoClick = (archivo) => {
    if (archivo) {
      // Editar o ver archivo existente
      setArchivoTarget(archivo);
      setComentarioArchivo('');
    } else {
      // Caso para agregar nuevo archivo
      setArchivoTarget(null); 
      setComentarioArchivo('');
    }
    setModalOpenFile(true);
  };

  const confirmarBloqueoArchivo = async () => {
    try {
      const esNuevo = !archivoTarget;
      const esDesbloqueo = archivoTarget?.blocked === 1;

      // Resetear errores
      setErrorNombreArchivo('');
      setErrorProcesoId('');
      console.log(esNuevo);
      // Validación para nuevo archivo
      if (esNuevo) {
        // Validar campos obligatorios
        if (!procesoId) {
          setErrorProcesoId('Debe seleccionar un proceso.');
          return;
        }

        if (!nombreArchivo.trim()) {
          setErrorNombreArchivo('El nombre del archivo es obligatorio.');
          return;
        }

        // Verificar si el archivo ya existe (solo para nuevos)
        try {
          const verificationResponse = await get('verificaArchivo', {
            params: {
              Id: null, 
              procesoId: Number(procesoId),
              nombreArchivo: nombreArchivo.trim()
            }
          });
          
          if (verificationResponse.existe) {
            setErrorNombreArchivo('Este archivo ya existe para el proceso seleccionado');
            toast.error('Este archivo ya existe para el proceso seleccionado');
            return;
          }
        } catch (verificationError) {
          console.error('Error verificando archivo:', verificationError);
          toast.error('Error al verificar archivo');
          return;
        }
      }

      const payload = {
        id: esNuevo ? null : archivoTarget?.id,
        Comment: comentarioArchivo,
        userId: user.id,
        NameFile: nombreArchivo.trim().toLowerCase() || archivoTarget?.NameFile, // Asegurar minúsculas
        ProcessId: esNuevo ? Number(procesoId) : archivoTarget?.ProcessId
      };

      // Determinar endpoint
      const endpoint = esNuevo ? 'nuevoFile' : 
                    esDesbloqueo ? 'desbloquearFile' : 'bloquearFile';

      // Enviar petición principal
      const response = await post(endpoint, payload);
      
      if (response) {
        toast.success('Operación exitosa');
        setModalOpenFile(false);
        setNombreArchivo('');
        setProceso('');
        fetchArchivosBloqueados();
      }

    } catch (error) {
      console.error('Error completo:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.errors?.NameFile?.[0] ||
                          'Error al procesar la operación';
      toast.error(errorMessage);
    }
  };

  // bloqueo proceso
  const onBloqueoClick = (proceso) => {
    if (!proceso) return;
    setProcesoTarget(proceso);
    setComentario('');
    setModalOpen(true);
  };


  const confirmarBloqueo = async () => {
    
      if (!procesoTarget) return;

      const { id, idprocesodet, bloqueado } = procesoTarget;
      const endpoint = bloqueado ? 'desbloquearProceso': 'bloquearProceso';

      // payload para desbloqueo; para bloqueo puedes omitir comentario si no lo necesitas
      const  payloadBase = {
          userId: user.id,
          comentario,
        }; 

      const payload = bloqueado
        ? { ...payloadBase, id:idprocesodet } // desbloqueo
        : { ...payloadBase, id, fechaInicio, fechaFin }; // bloqueo

        try {
        await post(endpoint, payload);     // llama a tu hook useApi
        fetchProcesosBloqueados();         // refresca lista
        setModalOpen(false);               // cierra modal
        
        toast.success(
          bloqueado
            ? `Proceso ${procesoTarget.procesoNombre} desbloqueado correctamente`
            : `Proceso ${procesoTarget.procesoNombre} bloqueado correctamente`
        );
        
      } catch (error) {
        console.error('Error bloqueando/desbloqueando proceso:', error);
        toast.error('Hubo un error al bloquear o desbloquear el proceso.');

      }
  };

  const handleVerProceso = (proceso) => {
    setProcesoSeleccionado(proceso);
    setMostrarHistorial(true);
  };

  const fetchProcesosBloqueados = async () => {
    try {
      const data = await get('procesos');
      setProcesosBloqueados(data);
    } catch {}
  };

  const fetchArchivosBloqueados = async () => {
    try {
      const data = await get('archivos');

      setArchivosBloqueados(data);
    } catch {}
  };

  const fetchProcesos = async () => {
    try {
      const data = await get('listaProcesos');
      setCatalogoProcesos(data);
    } catch {}
  };

  const fetchBloqueados = async () => {
    try {
      const data = await get('archivos');
      setArchivosBloqueados(data);
      setMostrandoArchivados(false);
    } catch (err) {
      console.error('Error al cargar bloqueados', err);
    }
  };
  
  const solicitarArchivado = (archivo) => {
    setArchivoTarget(archivo);
    setShowConfirm(true);
  };

  const archivarArchivo = async () => {
    if (!archivoTarget) return;

    try {
      const response = await get('archivar', {
            params: {Id: archivoTarget.id}
          });
      toast.success('Archivo archivado correctamente');
      setShowConfirm(false);
      fetchArchivosBloqueados(); // refresca la lista
    } catch (err) {
      toast.error('Error al archivar archivo');
    }
  };



  const fetchArchivados = async () => {
    try {
      const data = await get('archivados');
      setArchivosArchivados(data);
      setMostrandoArchivados(true); 
    } catch {}
  };


  useEffect(() => {
    fetchProcesosBloqueados();
    fetchArchivosBloqueados();
    fetchProcesos();
  }, []);

  const procesosFiltrados = useMemo(() => {
    if (!Array.isArray(procesosBloqueados)) return [];
    if (vistaActiva === 'procesosBloqueados') {
      return procesosBloqueados.filter(p => p.bloqueado);
    }
    if (vistaActiva === 'procesosSinBloqueo') {
      return procesosBloqueados.filter(p => !p.bloqueado);
    }
    return [];
  }, [vistaActiva, procesosBloqueados]);

  useEffect(() => {
  if (vistaActiva === 'archivos') {
    fetchArchivosBloqueados();
  }
}, [vistaActiva]);


  const columnsProcesos = [
  { header: 'ID', accessor: 'id' },
  {
    header: 'Proceso',
    accessor: 'procesoNombre', /**
    Cell: ({ value, row }) => {
      
      const bloqueado = row.bloqueado ?? false;
      const nombreProceso = value;

      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>{nombreProceso} {bloqueado}</span>
          <button
            onClick={() => onBloqueoClick(row)}
            style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer' }}
            title={bloqueado ? 'Desbloquear proceso' : 'Bloquear proceso'}
          >
            <Icon
              icon={bloqueado ? 'mdi:lock-outline' : 'mdi:lock-open-outline'}
              color={bloqueado ? 'red' : 'green'}
              width="16"
              height="16"
            />
          </button>
        </div>
      );
    }*/
  },
  { header: 'Fecha Inicio', accessor: 'startDate' },
  { header: 'Fecha Fin', accessor: 'endDate' },
  { header: 'Usuario', accessor: 'nombre' },
  { header: 'Comentarios', accessor: 'comment' },
];
const columnsArchivos = [
    { header: 'ID', accessor: 'id' },
    { header: 'Proceso', accessor: 'procesoNombre' },
    {
      header: 'Archivo',
      accessor: 'nameFile' /**,
      Cell: ({ row }) => {
        const blocked = row.blocked;

        return (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{row.nameFile}</span>
              {(blocked === 0 || blocked === 1) && (
                <div className='flex'>
                  <button
                    onClick={() => solicitarArchivado(row)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                    title="Archivar archivo"
                  >
                    <Icon
                      icon="mdi:archive"
                      color="blue"
                      width="16"
                      height="16"
                    />
                  </button>
                  <button
                    onClick={() => onBloqueoArchivoClick(row)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                    title={blocked ? 'Desbloquear archivo' : 'Bloquear archivo'}
                  >
                    <Icon
                      icon={blocked ? 'mdi:lock-outline' : 'mdi:lock-open-outline'}
                      color={blocked ? 'red' : 'green'}
                      width="16"
                      height="16"
                    />
                  </button>
                </div>
                )}
          </div>
        );
      }*/
    },
    { header: 'Usuario', accessor: 'usuarioNombre' },
    { header: 'Comentarios', accessor: 'comment' },
    { header: 'Fecha', accessor: 'createdAt' },
  ];
  

  const cardsData = [
  {
    icon: 'heroicons-outline:chart-pie',
    bgColor: 'bg-warning-500',
    textColor: 'text-warning-500',
    label: 'Procesos bloqueados',
    value: Array.isArray(procesosBloqueados)
      ? procesosBloqueados.filter((p) => p.bloqueado === true).length
      : 0,
    estatus: 'procesosBloqueados',
  },
  {
    icon: 'heroicons-outline:chart-pie',
    bgColor: 'bg-info-500',
    textColor: 'text-info-500',
    label: 'Procesos sin bloqueo',
    value: Array.isArray(procesosBloqueados)
      ? procesosBloqueados.filter((p) => !p.bloqueado).length
      : 0,
    estatus: 'procesosSinBloqueo',
  },
  {
    icon: 'heroicons-outline:calculator',
    bgColor: 'bg-success-500',
    textColor: 'text-success-500',
    label: 'Archivos',
    value: Array.isArray(archivosBloqueados)
      ? archivosBloqueados.length
      : 0,
    estatus: 'archivos',
  },
];


  return (
    <div className="p-1">
      <div className="md:flex items-center justify-between mb-2">
        <div className="flex-1">
          <label className="font-bold">Configuraciones</label>
        </div>
        <div className="flex-shrink-0 ml-auto">
          <InfoCards
            cardsData={cardsData}
            estatusActivo={vistaActiva}
            //onCardClick={setVistaActiva}
            onCardClick={(estatus) => {
              setVistaActiva(estatus);
              console.log(estatus);
              if (estatus === 'archivos') {
                setMostrandoArchivados(false); 
                fetchArchivosBloqueados(); 
              }
              }}
            loading={loading}
            error={error}
          />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-5">
        <div className="xl:col-span-12 col-span-12">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="p-6">
              {vistaActiva === 'archivos' ? (
                <>
                <div className="flex justify-between items-center mb-3">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => onBloqueoArchivoClick(null)}
                  >
                    + Agregar archivo
                  </button>
                  <button
                    className="btn btn-secondary btn-sm flex"
                    onClick={() => {
                      setMostrandoArchivados(true);
                      fetchArchivados();
                    }}
                  >
                    <Icon icon="mdi:archive" className="w-4 h-4 mr-2" />
                    Archivados
                  </button>
                </div>
                <TableWithPagination
                  columns={columnsArchivos}
                  data={(mostrandoArchivados ? archivosArchivados : archivosBloqueados).map((a) => ({
                    ...a,
                      createdAt: formatDate(a.createdAt),
                    }))}
                  showView={false}
                  showEdit={false}
                  showDelete={false}
                  renderExtraActions={(row) => {
                    const blocked = row.blocked;

                    if (blocked === 0 || blocked === 1) {
                      return (
                        <div className="flex gap-2">
                          <button
                            onClick={() => solicitarArchivado(row)}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                            title="Archivar archivo"
                          >
                            <Icon icon="mdi:archive" color="blue" width="16" height="16" />
                          </button>
                          <button
                            onClick={() => onBloqueoArchivoClick(row)}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                            title={blocked ? 'Desbloquear archivo' : 'Bloquear archivo'}
                          >
                            <Icon
                              icon={blocked ? 'mdi:lock-outline' : 'mdi:lock-open-outline'}
                              color={blocked ? 'red' : 'green'}
                              width="16"
                              height="16"
                            />
                          </button>
                        </div>
                      );
                    }

                    return null;
                  }}


                />
                <Modal
                    show={modalOpenFile}
                    onClose={() => setModalOpenFile(false)}
                    title={
                      archivoTarget
                        ? archivoTarget.blocked
                          ? `Desbloquear archivo`
                          : `Bloquear archivo`
                        : `Agregar nuevo archivo`
                    }
                    footer={
                      <>
                        <button
                          onClick={() => setModalOpenFile(false)}
                          className="btn btn-sm btn-secondary"
                        >
                          Cancelar
                        </button>
                        <button
                          onClick={confirmarBloqueoArchivo}
                          className="btn btn-sm btn-primary"
                        >
                          {archivoTarget ? 'Confirmar' : 'Agregar'}
                        </button>
                      </>
                    }
                  > 
                      {!archivoTarget ? (
                        // Caso: archivo nuevo → campo para ingresar nombre | Proceso
                        <>
                          <div className="mb-4">
                            <label
                              htmlFor="nombreArchivo"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Proceso
                            </label>
                            <select
                              value={procesoId || ''}
                              onChange={(e) => {
                                setProceso(e.target.value);
                                if (errorProcesoId) setErrorProcesoId('');
                              }}
                              className="mb-4 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            >
                              <option value="">Seleccione un proceso</option>
                              {catalogoProcesos.map((proceso) => (
                                <option key={proceso.id} value={proceso.id}>
                                  {proceso.procesoNombre}
                                </option>
                              ))}
                            </select>
                            {errorProcesoId && (
                                <p className="mt-0 text-xs text-red-600">{errorProcesoId}</p>
                              )}
                          </div>
                          <div className="mb-4">
                            <label
                              htmlFor="nombreArchivo"
                              className="block text-sm font-medium text-gray-700 mb-1"
                            >
                              Nombre del archivo
                            </label>
                            <input
                              type="text"
                              placeholder="Nombre del archivo"
                              value={nombreArchivo}
                              onChange={(e) => {
                                setNombreArchivo(e.target.value);
                                if (errorNombreArchivo) setErrorNombreArchivo('');
                              }}
                              className="mb-4 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            />
                            {errorNombreArchivo && (
                              <p className="mt-0 text-xs text-red-600">{errorNombreArchivo}</p>
                            )}
                          </div>
                        </>
                      ) : (
                        // Caso: archivo existente → mostrar nombre del archivo
                        <div className="mb-4 flex gap-3">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Archivo
                          </label>
                          <p className="text-sm text-gray-900 font-semibold">
                            {archivoTarget.nameFile}
                          </p>
                        </div>
                      )}

                    <textarea
                      placeholder="Agrega un comentario..."
                      value={comentarioArchivo}
                      onChange={(e) => setComentarioArchivo(e.target.value)}
                      rows={4}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none text-sm"
                    />
                  </Modal>

                  </>
              ) : mostrarHistorial ? (
                <HistorialProceso
                  proceso={procesoSeleccionado}
                  onBack={() => setMostrarHistorial(false)}
                />
              ) : (
                <>
                  <TableWithPagination
                      columns={columnsProcesos}
                      data={procesosFiltrados.map((p) => ({
                        ...p,
                        startDate: formatDate(p.startDate),
                        endDate: formatDate(p.endDate),
                      }))}
                      onView={handleVerProceso}
                      showView={true}
                      showEdit={false}
                      showDelete={false}
                      renderExtraActions={(row) => (
                        <button
                          onClick={() => onBloqueoClick(row)}
                          className="p-1"
                          title={row.bloqueado ? 'Desbloquear proceso' : 'Bloquear proceso'}
                        >
                          <Icon
                            icon={row.bloqueado ? 'mdi:lock-outline' : 'mdi:lock-open-outline'}
                            color={row.bloqueado ? 'red' : 'green'}
                            width="18"
                            height="18"
                          />
                        </button>
                      )}
                  />
                <Modal
                  show={modalOpen && procesoTarget}
                  onClose={() => setModalOpen(false)}
                  title={
                    procesoTarget?.bloqueado 
                      ? `Desbloquear ${procesoTarget?.procesoNombre || ''}` 
                      : `Bloquear ${procesoTarget?.procesoNombre || ''}`
                  }

                  footer={
                    <>
                      <button onClick={() => setModalOpen(false)} className="btn btn-sm btn-secondary">Cancelar</button>
                      <button onClick={confirmarBloqueo} className="btn btn-sm btn-primary">Confirmar</button>
                    </>
                  }
                >
                  {!procesoTarget?.bloqueado &&(
                    <>
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1" htmlFor="fechaInicio">Fecha y Hora Inicio</label>
                        <input
                          type="datetime-local"
                          id="fechaInicio"
                          value={fechaInicio || ''}
                          onChange={(e) => setFechaInicio(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                        />
                      </div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1" htmlFor="fechaFin">Fecha y Hora Fin</label>
                        <input
                          type="datetime-local"
                          id="fechaFin"
                          value={fechaFin || ''}
                          onChange={(e) => setFechaFin(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                        />
                      </div>
                      </>
                    )}
                  <textarea
                    placeholder="Agrega un comentario..."
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none text-sm"
                  />

                </Modal>
                </>

              )}
            </div>
          </div>
        </div>
      </div>
      <ConfirmDialog
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={archivarArchivo}
        title="¿Archivar archivo?"
        message="¿Estás seguro que deseas archivar este archivo? Esta acción no se puede deshacer."
      />

    </div>
  );
}
